import { useControlUnitsByIds } from './useControlUnitsByIds';
import { useGroupById } from '../../groups/hooks/useGroupById';
import { useMemo } from 'react';
import { useAdaptableParams } from '../../../util/hooks/useAdaptableParams';

export function useDevicesControlUnits(options?: { hideCommander?: boolean }) {
  const params = useAdaptableParams<{
    deviceId?: string;
    groupId?: string;
    controlUnitId?: string;
  }>();
  const { groupId, deviceId, controlUnitId } = params;
  const {
    data: group,
    isLoading: groupsLoading,
    error: groupError,
  } = useGroupById(groupId);

  const {
    data: devicesControlUnitsSource,
    isLoading: devicesControlUnitsLoading,
    error: devicesControlUnitsError,
  } = useControlUnitsByIds({
    ...options,
    deviceIds: group?.devices ?? [],
  });
  // filter by QueryParam
  const devicesControlUnits = useMemo(() => {
    let devicesControlUnitsTemp = devicesControlUnitsSource;
    // deviceId
    if (deviceId)
      devicesControlUnitsTemp = devicesControlUnitsSource.filter(
        (devicesControlUnit) => devicesControlUnit.deviceId === deviceId
      );
    // controlUnitId
    if (controlUnitId)
      devicesControlUnitsTemp = devicesControlUnitsSource.map(
        (devicesControlUnit) => ({
          ...devicesControlUnit,
          controlUnits: devicesControlUnit.controlUnits?.filter(
            (controlUnit) => controlUnit.id == controlUnitId
          ),
        })
      );
    return devicesControlUnitsTemp;
  }, [devicesControlUnitsSource, deviceId, controlUnitId]);

  const loading = groupsLoading || devicesControlUnitsLoading;
  const error = groupError || devicesControlUnitsError;

  return [devicesControlUnits, loading, error] as const;
}
